function getFlashVersions() {
    var UNDEF = "undefined",
        OBJECT = "object",
        SHOCKWAVE_FLASH = "Shockwave Flash",
        SHOCKWAVE_FLASH_AX = "ShockwaveFlash.ShockwaveFlash",
        FLASH_MIME_TYPE = "application/x-shockwave-flash",
        EXPRESS_INSTALL_ID = "SWFObjectExprInst",
        ON_READY_STATE_CHANGE = "onreadystatechange",
        win = window,
        doc = document,
        nav = navigator,
        plugin = false,
        domLoadFnArr = [],
        regObjArr = [],
        objIdArr = [],
        listenersArr = [],
        storedFbContent,
        storedFbContentId,
        storedCallbackFn,
        storedCallbackObj,
        isDomLoaded = false,
        isExpressInstallActive = false,
        dynamicStylesheet,
        dynamicStylesheetMedia,
        autoHideShow = true,
        encodeURIEnabled = false;

    function toInt(str) {
        return parseInt(str, 10);
    }
    var w3cdom =
        typeof doc.getElementById !== UNDEF &&
        typeof doc.getElementsByTagName !== UNDEF &&
        typeof doc.createElement !== UNDEF,
        u = nav.userAgent.toLowerCase(),
        p = nav.platform.toLowerCase(),
        windows = p ? /win/.test(p) : /win/.test(u),
        mac = p ? /mac/.test(p) : /mac/.test(u),
        webkit = /webkit/.test(u) ?
        parseFloat(u.replace(/^.*webkit\/(\d+(\.\d+)?).*$/, "$1")) :
        false,
        // returns either the webkit version or false if not webkit
        ie = nav.appName === "Microsoft Internet Explorer",
        playerVersion = [0, 0, 0],
        d = null;
    if (
        typeof nav.plugins !== UNDEF &&
        typeof nav.plugins[SHOCKWAVE_FLASH] === OBJECT
    ) {
        d = nav.plugins[SHOCKWAVE_FLASH].description;
        // nav.mimeTypes["application/x-shockwave-flash"].enabledPlugin indicates whether plug-ins are enabled or disabled in Safari 3+
        if (
            d &&
            (typeof nav.mimeTypes !== UNDEF &&
                nav.mimeTypes[FLASH_MIME_TYPE] &&
                nav.mimeTypes[FLASH_MIME_TYPE].enabledPlugin)
        ) {
            plugin = true;
            ie = false; // cascaded feature detection for Internet Explorer
            d = d.replace(/^.*\s+(\S+\s+\S+$)/, "$1");
            playerVersion[0] = toInt(d.replace(/^(.*)\..*$/, "$1"));
            playerVersion[1] = toInt(d.replace(/^.*\.(.*)\s.*$/, "$1"));
            playerVersion[2] = /[a-zA-Z]/.test(d) ?
                toInt(d.replace(/^.*[a-zA-Z]+(.*)$/, "$1")) :
                0;
        }
    } else if (typeof win.ActiveXObject !== UNDEF) {
        try {
            var a = new ActiveXObject(SHOCKWAVE_FLASH_AX);
            if (a) {
                // a will return null when ActiveX is disabled
                d = a.GetVariable("$version");
                if (d) {
                    ie = true; // cascaded feature detection for Internet Explorer
                    d = d.split(" ")[1].split(",");
                    playerVersion = [toInt(d[0]), toInt(d[1]), toInt(d[2])];
                }
            }
        } catch (e) {}
    }
    return {
        w3: w3cdom,
        pv: playerVersion, // flash player version
        wk: webkit,
        ie: ie,
        win: windows,
        mac: mac
    };
}


/*
 * 检测当前浏览器信息
 */
function detect(ua) {
    ua = ua || navigator.userAgent;
    var os = {};
    var browser = {};
    var webkit = ua.match(/Web[kK]it[\/]{0,1}([\d.]+)/);
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
    var webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/);
    var touchpad = webos && ua.match(/TouchPad/);
    var kindle = ua.match(/Kindle\/([\d.]+)/);
    var silk = ua.match(/Silk\/([\d._]+)/);
    var blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/);
    var bb10 = ua.match(/(BB10).*Version\/([\d.]+)/);
    var rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/);
    var playbook = ua.match(/PlayBook/);
    var chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/);
    var firefox = ua.match(/Firefox\/([\d.]+)/);
    //var ie = ua.match(/MSIE ([\d.]+)/);
    var safari = webkit && ua.match(/Mobile\//) && !chrome;
    var webview = ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/) && !chrome;
    var ie = ua.match(/MSIE\s([\d.]+)/)
        // IE 11 Trident/7.0; rv:11.0
        || ua.match(/Trident\/.+?rv:([\d.]+)/);
    // Todo: clean this up with a better OS/browser seperation:
    // - discern (more) between multiple browsers on android
    // - decide if kindle fire in silk mode is android or not
    // - Firefox on Android doesn't specify the Android version
    // - possibly devide in os, device and browser hashes
    if (browser.webkit = !!webkit)
        browser.version = webkit[1];
    if (android)
        os.android = true, os.version = android[2];
    if (iphone && !ipod)
        os.ios = os.iphone = true, os.version = iphone[2].replace(/_/g, '.');
    if (ipad)
        os.ios = os.ipad = true, os.version = ipad[2].replace(/_/g, '.');
    if (ipod)
        os.ios = os.ipod = true, os.version = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
    if (webos)
        os.webos = true, os.version = webos[2];
    if (touchpad)
        os.touchpad = true;
    if (blackberry)
        os.blackberry = true, os.version = blackberry[2];
    if (bb10)
        os.bb10 = true, os.version = bb10[2];
    if (rimtabletos)
        os.rimtabletos = true, os.version = rimtabletos[2];
    if (playbook)
        browser.playbook = true;
    if (kindle)
        os.kindle = true, os.version = kindle[1];
    if (silk)
        browser.silk = true, browser.version = silk[1];
    if (!silk && os.android && ua.match(/Kindle Fire/))
        browser.silk = true;
    if (chrome)
        browser.chrome = true, browser.version = chrome[1];
    if (firefox)
        browser.firefox = true, browser.version = firefox[1];
    if (ie)
        browser.ie = true, browser.version = ie[1];
    if (safari && (ua.match(/Safari/) || !!os.ios))
        browser.safari = true;
    if (webview)
        browser.webview = true;
    if (ie)
        browser.ie = true, browser.version = ie[1];
    os.tablet = !!(ipad || playbook || android && !ua.match(/Mobile/) || firefox && ua.match(/Tablet/) || ie && !ua.match(/Phone/) && ua.match(/Touch/));
    os.phone = !!(!os.tablet && !os.ipod && (android || iphone || webos || blackberry || bb10 || chrome && ua.match(/Android/) || chrome && ua.match(/CriOS\/([\d.]+)/) || firefox && ua.match(/Mobile/) || ie && ua.match(/Touch/)));
    return {
        browser: browser,
        os: os,
        // 原生canvas支持，改极端点了
        // canvasSupported : !(browser.ie && parseFloat(browser.version) < 9)
        canvasSupported: document.createElement('canvas').getContext ? true : false
    };
}


function checkUnableSwf() {
    let flashObj = getFlashVersions();
    let version = flashObj.pv.join('.');
    let browser = detect();
    browser.flashCanIUse = version !== '0.0.0';
    alert(JSON.stringify(browser));
    return version !== '0.0.0'
}

function getBrowserContext() {
    let flashObj = getFlashVersions();
    let version = flashObj.pv.join('.');
    let browser = detect();
    let browserVer = browser.browser.version;
    let code = browserVer.match(/([\d+]+)/);

    return Object.assign({
        flashCanIUse: version !== '0.0.0',
        canvasSupported: browser.canvasSupported,
        code: Array.isArray(code) ? code[0] : browserVer,
        os: browser.os
    }, browser.browser);
}
export {
    checkUnableSwf,
    getBrowserContext
}
